import * as _ from "lodash";

export class DashboardWidgetStyle {
    public colorPalette = null;
    public chartType: string = "donut";
    public tableType: string = "";
    public chartOptions: any = {
        stacked: true,
        showLabels: false,
        labelFigure: "percent",
    };
    public tableOptions: any = {
        showEmptyRows: false,
        figures: "count",
        columns: [],
        rows: [],
    };
    public fontSize = { figure: 36, label: 10 };
    public legend = { show: true, position: "bottom" };

    constructor(data?: any) {
        this.setData(data);
    }

    setData(data: any): void {
        _.merge(this, data);

        if (data && data.tableOptions && data.tableOptions.columns) {
            this.tableOptions.columns = data.tableOptions.columns;
        }
        if (data && data.tableOptions && data.tableOptions.rows) {
            this.tableOptions.rows = data.tableOptions.rows;
        }
    }
}
